export default __webpack_public_path__ + "assets/images/42b4818b9ab0050da712822803841a63.png";